import session from 'redux-persist/lib/storage/session';
// import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'speedy',
      storage: session,
      whitelist: ['auth'],
    },
    reducers
  );
  return persistedReducer;
};
